<template>
  <el-form
    :model="optionData"
    :rules="optionRules"
    label-width="100px"
  >
    <el-form-item label="图形标题" prop="title">
      <el-input style="width: 320px;max-width: 500px;" placeholder="请输入折线图显示标题..." :minlength="3" :maxlength="20" v-model="optionData.title"></el-input>
    </el-form-item>
    <el-form-item label="平滑曲线" prop="smooth">
      <el-switch v-model="optionData.smooth"></el-switch>
    </el-form-item>
    <el-form-item label="面积填充" prop="areaStyle">
      <el-switch v-model="optionData.areaStyle"></el-switch>
    </el-form-item>
    <el-form-item label="显示节点数值" prop="label">
      <el-switch v-model="optionData.label"></el-switch>
    </el-form-item>
    <el-form-item label="显示图例" prop="legend">
      <el-switch v-model="optionData.legend"></el-switch>
    </el-form-item>
    <el-form-item label="提供图片下载" prop="saveAsImage">
      <el-switch v-model="optionData.saveAsImage"></el-switch>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      optionData: {
        title: "",
        smooth: false,
        areaStyle: false,
        label: false,
        legend: false,
        saveAsImage: false,
      },
      optionRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 3, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getOption() {
      if(!this.optionData.title.trim()) {
        return "请输入图形标题！"
      }
      return {
        title: this.optionData.title,
        smooth: this.optionData.smooth,
        areaStyle: this.optionData.areaStyle ? true : false,
        label: {
          show: this.optionData.label,
          position: 'top'
        },
        legend: this.optionData.legend ? true : false,
        saveAsImage: {
          feature: {
            saveAsImage: this.optionData.saveAsImage ? {} : null
          }
        }
      }
    }
  }
};
</script>
